<script>
import { defineComponent, ref, onBeforeUnmount } from 'vue'
export default defineComponent({
  name: 'TimeCounter',
  components: {},

  setup() {
    const title = ref('距离开始')
    const hour1 = ref(0)
    const hour2 = ref(0)

    const min1 = ref(0)
    const min2 = ref(0)

    const sec1 = ref(0)
    const sec2 = ref(0)
    var day = ref(0)
    // 获取目标时间和当前时间
    const startTime = new Date('2023/06/30 12:30:00') // 设置目标时间
    const endTime = new Date('2023/06/30 13:30:00') // 设置目标时间

    let timer
    const startTimer = () => {
      timer = setInterval(function () {
        var currentTime = new Date()
        const timeDiff = startTime.getTime() - currentTime.getTime()
        let remainingSeconds = Math.floor(timeDiff / 1000)
        day.value = Math.floor(timeDiff / 1000 / 3600 / 24)
        var hours = formatTime(Math.floor(remainingSeconds / 3600))
        if (day.value >= 1) {
          hours = formatTime(Math.floor(remainingSeconds / 3600) - day.value * 24)
        }
        remainingSeconds %= 3600
        const minutes = formatTime(Math.floor(remainingSeconds / 60))
        const seconds = formatTime(remainingSeconds % 60)
        if (remainingSeconds < 0) {
          const timeDiff2 = endTime.getTime() - currentTime.getTime()
          day.value = Math.floor(timeDiff2 / 1000 / 3600 / 24)
          let remainingSeconds2 = Math.floor(timeDiff2 / 1000)
          var hours2 = formatTime(Math.floor(remainingSeconds2 / 3600))
          if (day.value >= 1) {
            hours2 = formatTime(Math.floor(remainingSeconds2 / 3600) - day.value * 24)
          }
          remainingSeconds %= 3600
          const minutes2 = formatTime(Math.floor(remainingSeconds2 / 60))
          const seconds2 = formatTime(remainingSeconds2 % 60)
          if (remainingSeconds2 < 0) {
            title.value = '已结束'
            stopTimer()
            hour1.value = '0'
            hour2.value = '0'
            min1.value = '0'
            min2.value = '0'
            sec1.value = '0'
            sec2.value = '0'
          } else {
            title.value = '距离结束'
            hour1.value = hours2[0]
            hour2.value = hours2[1]
            min1.value = minutes2[0]
            min2.value = minutes2[1]
            sec1.value = seconds2[0]
            sec2.value = seconds2[1]
          }
        } else {
          title.value = '距离开始'
          hour1.value = hours[0]
          hour2.value = hours[1]
          min1.value = minutes[0]
          min2.value = minutes[1]
          sec1.value = seconds[0]
          sec2.value = seconds[1]
        }
      }, 1000)
    }
    // 格式化时间，补零显示
    function formatTime(time) {
      return '' + (time < 10 ? '0' + time : time)
    }

    const stopTimer = () => {
      clearInterval(timer)
    }

    onBeforeUnmount(() => {
      stopTimer()
    })

    startTimer()

    return {
      title: title,
      day: day,
      hour1: hour1,
      hour2: hour2,
      min1: min1,
      min2: min2,
      sec1: sec1,
      sec2: sec2
    }
  }
})
</script>

<template>
  <div class="T">
    <span class="TS1">{{ title }}</span>
    <div class="TSpan3">
      <div class="TSpan3SItem">
        <span class="TSpan3SItemB">{{ hour1 }}</span>
        <span class="TSpan3SItemB">{{ hour2 }}</span>
      </div>
      <div class="TSpan3SItemD">
        <span class="TSpan3SItemDDot"></span>
        <span class="TSpan3SItemDDot"></span>
      </div>
      <div class="TSpan3SItem">
        <span class="TSpan3SItemB">{{ min1 }}</span>
        <span class="TSpan3SItemB">{{ min2 }}</span>
      </div>
      <div class="TSpan3SItemD">
        <span class="TSpan3SItemDDot"></span>
        <span class="TSpan3SItemDDot"></span>
      </div>
      <div class="TSpan3SItem">
        <span class="TSpan3SItemB">{{ sec1 }}</span>
        <span class="TSpan3SItemB">{{ sec2 }}</span>
      </div>
    </div>
    <div class="TR">
      <span class="TRSRed">{{ day }}</span> <span class="TRNormal">天</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.T {
  display: flex;
  flex-direction: row;
  bottom: 4.25rem;
  width: 22.5rem;
  height: 5.9375rem;
  &R {
    position: absolute;
    display: flex;
    flex-direction: column;
    right: 3.25rem;
    height: 100%;
    justify-content: center;
    // background: blue;
    // opacity: 0.5;

    // line-height: 1.6875rem;
    &SRed {
      margin-top: -0.325rem;
      font-size: 2.25rem;
      font-family: MicrosoftYaHei;
      font-weight: bold;
      color: white;
      // background: yellow;
      // margin-bottom: 0.5625rem;
    }
    &Normal {
      // background: blue;
      margin-top: -1rem;
      font-size: 1.6875rem;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: white;
      // margin-bottom: 0.5625rem;
    }
  }
  &S1 {
    display: block;
    height: 100%;
    writing-mode: vertical-lr; /*从左向右 从右向左是 writing-mode: vertical-rl;*/
    // writing-mode: tb-lr; /*IE浏览器的从左向右 从右向左是 writing-mode: tb-rl；*/
    -ms-writing-mode: vertical-lr;
    margin-left: 3.4375rem;
    font-weight: 700;
    font-size: 1.1rem;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: white;
  }
  &Span3 {
    position: absolute;
    top: 8%;
    bottom: 10%;
    left: 0;
    right: 0;
    margin: auto;
    display: flex;
    height: 85%;
    width: 62%;
    // background-color: red;
    padding-bottom: 0.5rem;
    padding-top: 0.375rem;
    align-items: center; /* 垂直居中 */
    &SItem {
      display: flex;
      flex-direction: row;
      margin-right: 0.6125rem;
      margin-left: 0.25rem;
      width: 100%;
      height: 100%;
      &B {
        margin-left: 0.125rem;
        min-width: 1.9375rem;
        height: 100%;
        width: 2rem;
        // line-height:5.0625rem;
        font-size: 2.5rem;
        font-family: TypeRegular;
        font-weight: bold;
        color: #fef3df;
        background: #1a1a1a;
        box-shadow: 0rem 0.0625rem 0rem 0rem #ffffff, 0rem 0.125rem 0rem 0rem rgba(133, 79, 21, 0.3);
        border-radius: 0.3125rem;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      &D {
        width: 0.4375rem;
        height: 1.625rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        &Dot {
          width: 0.4375rem;
          height: 0.4375rem;
          background: #1a1a1a;
          box-shadow: 0rem 0.0625rem 0rem 0rem #ffffff,
            0rem 0.125rem 0rem 0rem rgba(133, 79, 21, 0.3);
          border-radius: 50%;
        }
      }
    }
  }
}
</style>
